export let imprint = `<p>
<strong>Tobias Herber</strong>
</p>
<p>Kristein 3</p>
<p>4470 Enns</p>
<p>Österreich</p>
<br />
<p>
<strong>Email</strong>: tobias@herber.space
</p>
<br />
<p>
<strong>Telefon</strong>: +436641963604
</p>
<br />
<p>
<strong>Unternehmensgegenstand</strong>: Dienstleistungen in der automatischen
Datenverarbeitung und Informationstechnik, Softwareentwicklung.
</p>
<br />
<p>
<strong>Aufsichtsbehörde/Gewerbebehörde:</strong> Bezirkshauptmannschaft Linz-Land
</p>
<p>Anwendbare Rechtsvorschriften: Berufsrecht, Gewerbeordnung: www.ris.bka.gv.at</p>
<br />
<p>
<strong>Rechtsform</strong>: Einzelunternehmen
</p>
<br />
<p>
<strong>UST ID:</strong> ATU78363904
</p>
<br />
<p>
<strong>Mitglied der</strong> WKO, WKO Oberösterreich, FG Unternehmensberatung,
Buchhaltung und Informationstechnik
</p>
<br />

<p>
<strong>Angaben zur Online-Streitbeilegung</strong>: Verbraucher haben die
Möglichkeit, Beschwerden an die Online Streitbeilegungsplattform der EU zu richten:
http://ec.europa.eu/odr.
</p>`;
